import React, { useEffect, useState } from 'react';
import moment from 'moment';

interface CountdownProps {
  eventData: {
    start_date: string;
    end_date: string;
    country?: string;
    city?: string;
    
  };
}

const Countdown: React.FC<CountdownProps> = ({ eventData }) => {
  const formatEventDateRange = (start: string, end: string) => {
    const startDay = moment(start).format('DD');
    const endDay = moment(end).format('DD');
    const monthYear = moment(start).format('MMMM, YYYY');
    return `${startDay} - ${endDay} ${monthYear}`;
  };

  const eventStartDate = moment(eventData.start_date).toDate();
  const eventDateRange = formatEventDateRange(eventData.start_date, eventData.end_date);

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = eventStartDate.getTime() - now;
      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((distance / (1000 * 60)) % 60),
        seconds: Math.floor((distance / 1000) % 60)
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [eventStartDate]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="home-bottom-area">
            <div className="row">
              <div className="venue col-lg-5 col-sm-12">
                <div className="date">
                  <span className="icon icon-calendar" style={{ color:eventData.primary_color }}></span> {eventDateRange}
                </div>
                <div className="location">
                <span className="icon icon-location" style={{ color:eventData.primary_color }}></span> {`${eventData.city}, ${eventData.country}`}
                </div>
                <div className="date">
                
                   <span className="icon icon-clock" style={{ color: eventData.primary_color, marginRight: 12 }}></span>{eventData.time_zone}
                </div>
              </div>
              <div className="col-lg-7 col-sm-12">
                <div id="countdown" className="row text-center">
                  {['days', 'hours', 'minutes', 'seconds'].map((unit, idx) => (
                    <div className="col-3" key={idx}>
                      <div className="count-circle" style={{ border:'2px dotted'+eventData.primary_color }}>
                        <h3>{timeLeft[unit as keyof typeof timeLeft]}</h3>
                      </div>
                      <p>{unit.charAt(0).toUpperCase() + unit.slice(1)}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
